import React from "react";
import { useLanguage } from "@/context/LanguageContext";

export const Philosophy = () => {
  const { t } = useLanguage();
  return (
    <section
      id="philosophy"
      data-testid="philosophy-section"
      className="relative bg-[#0A0A0A] border-t border-white/5"
    >
      <div className="max-w-5xl mx-auto px-6 md:px-12 py-24 md:py-32 text-center">
        <div className="eyebrow mb-6" data-testid="philosophy-eyebrow">
          {t.philosophy.eyebrow}
        </div>
        <h2
          data-testid="philosophy-title"
          className="font-serif-display text-4xl sm:text-5xl md:text-6xl font-light text-[#F8F8F8] leading-[1.1] tracking-tight"
        >
          {t.philosophy.title}
        </h2>
        <p
          data-testid="philosophy-body"
          className="mt-10 text-base md:text-lg text-[#A1A1AA] font-light leading-relaxed max-w-3xl mx-auto"
        >
          {t.philosophy.body}
        </p>

        <div className="mt-16 border-y border-[#D4AF37]/20 py-10">
          <p
            data-testid="philosophy-quote"
            className="font-serif-display text-2xl md:text-3xl italic text-[#D4AF37] font-light"
          >
            {t.philosophy.quote}
          </p>
        </div>
      </div>
    </section>
  );
};

export default Philosophy;
